const uwModelStyles = (defaultStyle: ReactModal.Styles): ReactModal.Styles => ({
  ...defaultStyle,
  content: {
    ...defaultStyle.content,
    position: 'initial',
    width: '100%',
    height: '100%',
    background: '#ffff',
    padding: 'unset',
  },
  overlay: {
    ...defaultStyle.overlay,
    background: 'rgba(0, 0, 0, .85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1001,
  },
});

export default uwModelStyles;
